<template>
  <div
    class="ce-otherResultsHint"
    v-if="canViewFormulations && hasFormulationRsults">
    <i18n-t
      keypath="productSearch.formulationResultsHint.content"
      tag="span"
      scope="global">
      {{ $t('productSearch.formulationResultsHint.prefix', formulationResults.total) }}
      <a :href="link">
        {{ $t('productSearch.formulationResultsHint.link', 2) }}
      </a>
    </i18n-t>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import qs from 'qs';
import SearchConfig from '@sun-chemical/system-config/search-config';
import { cloneObject } from 'utils';

export default {
  computed: {
    ...mapState(['results']),
    ...mapState('generic', ['links']),
    ...mapGetters('user', ['canViewFormulations']),
    formulationResults() {
      return this.results?.formulations;
    },
    hasFormulationRsults() {
      return this.formulationResults?.total > 0;
    },
    link() {
      let link = `${this.links.formulationRepositoryPage}`;

      if (this.formulationResults?.params && Object.keys(this.formulationResults.params).length > 0) {
        const params = cloneObject(this.formulationResults.params);
        const termParam = SearchConfig.getMap().search_term.param;

        if (params[termParam]) {
          params[termParam] = encodeURIComponent(params[termParam]);
        }

        link += `?${qs.stringify(params, { arrayFormat: 'comma', encode: false })}`;
      }

      return link;
    }
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-otherResultsHint {
  position: relative;
  .ms(-2);
  margin: 0 0 @space-2;
  text-align: right;
}
</style>
